module.exports = __webpack_public_path__ + "static/media/list-empty.11b01416.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/list-empty.png
// module id = 1940
// module chunks = 6